import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import {
  Box,
  Typography,
  Stack,
  TextField,
  InputAdornment,
  IconButton,
  CircularProgress,
  Alert,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import EditIcon from "@mui/icons-material/Edit";
import ModalEmpresas from "../componentes/modalempresa";
import EditarEmpresa from "../componentes/editarempresa";

export default function TablaEmpresasPremium() {
  const [empresa, setEmpresa] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [search, setSearch] = useState("");

  useEffect(() => {
    getEmpresas();
  }, []);

  const getEmpresas = async () => {
    try {
      setLoading(true);
      setError("");
      const res = await axios.get(process.env.REACT_APP_API_EMPRESAS);
      setEmpresa(res.data);
    } catch (err) {
      console.error(err);
      setError("Error al cargar empresas");
    } finally {
      setLoading(false);
    }
  };

  const deleteEmpresa = async (idEmpresa) => {
    if (!window.confirm("¿Eliminar empresa?")) return;

    try {
      await axios.post(
        `${process.env.REACT_APP_API_EMPRESAS_ELIMINAR}?id=${idEmpresa}`
      );
      getEmpresas();
    } catch (err) {
      console.error(err);
      setError("Error al eliminar empresa");
    }
  };

  const filteredData = useMemo(() => {
    return empresa.filter((e) =>
      [e.empresa, e.rut, e.direccion]
        .join(" ")
        .toLowerCase()
        .includes(search.toLowerCase())
    );
  }, [empresa, search]);

  return (
    <Box sx={{ p: 3 }}>
      {/* HEADER */}
      <Stack
        direction={{ xs: "column", md: "row" }}
        justifyContent="space-between"
        alignItems="center"
        spacing={2}
        sx={{ mb: 3 }}
      >
        <Box>
          <Typography variant="h4" fontWeight={700}>
            Empresas
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Administración y gestión de empresas registradas
          </Typography>
        </Box>

        <Stack direction="row" spacing={2}>
          <TextField
            size="small"
            placeholder="Buscar empresa..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              )
            }}
          />
          <ModalEmpresas />
        </Stack>
      </Stack>

      {/* ERROR */}
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

      {/* LOADING */}
      {loading ? (
        <Box display="flex" justifyContent="center" mt={4}>
          <CircularProgress />
        </Box>
      ) : (
        <TableContainer
          component={Paper}
          sx={{
            borderRadius: 3,
            overflow: "hidden",
            boxShadow: "0 4px 20px rgba(0,0,0,0.05)"
          }}
        >
          <Table>
            <TableHead>
              <TableRow sx={{ background: "linear-gradient(90deg, #1976d2, #42a5f5)" }}>
                <TableCell sx={{ color: "#fff", fontWeight: 600 }}>ID</TableCell>
                <TableCell sx={{ color: "#fff", fontWeight: 600 }}>Empresa</TableCell>
                <TableCell sx={{ color: "#fff", fontWeight: 600 }}>RUT</TableCell>
                <TableCell sx={{ color: "#fff", fontWeight: 600 }}>Dirección</TableCell>
                <TableCell sx={{ color: "#fff", fontWeight: 600 }}>Acciones</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {filteredData.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    No se encontraron empresas
                  </TableCell>
                </TableRow>
              ) : (
                filteredData.map((emp) => (
                  <TableRow
                    key={emp.idEmpresa}
                    sx={{ "&:hover": { backgroundColor: "rgba(25, 118, 210, 0.08)" } }}
                  >
                    <TableCell>{emp.idEmpresa}</TableCell>
                    <TableCell>{emp.empresa}</TableCell>
                    <TableCell>{emp.rut}</TableCell>
                    <TableCell>{emp.direccion}</TableCell>
                    <TableCell>
                      <Stack direction="row" spacing={1}>
                        <Tooltip title="Editar">
                          <EditarEmpresa empresa={emp}>
                            <IconButton color="primary">
                              <EditIcon />
                            </IconButton>
                          </EditarEmpresa>
                        </Tooltip>

                        <Tooltip title="Eliminar">
                          <IconButton
                            color="error"
                            onClick={() => deleteEmpresa(emp.idEmpresa)}
                          >
                            <DeleteForeverIcon />
                          </IconButton>
                        </Tooltip>
                      </Stack>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
}